import React from "react";

/**
 * Zona de peligro: título en rojo, texto explicativo y el botón destructivo.
 *  - title: texto del título
 *  - text: texto explicativo (.rev-danger__text)
 *  - action: el botón (normalmente <RevButton variant="danger">)
 */
const RevDanger = ({ title, text, action, ...rest }) => (
    <div className="rev-danger" {...rest}>
        <div className="rev-danger__main">
            <span className="rev-danger__title">{title}</span>
            {text && <span className="rev-danger__text">{text}</span>}
        </div>
        {action}
    </div>
);

export default RevDanger;
